module.exports = __webpack_public_path__ + "img/telegram 3.341107cd.svg";